export enum TotalCardOrderStatus {
    Created = 0,
    Activated = 3,
    Cancelled = 4,
}
